import React, { Component } from "react";
import { bool, func, node, oneOf, string } from "prop-types";

import * as S from "./styled";

/**
 * @deprecated use @streeteasy/design-system/button-action or @streeteasy/design-system/text-action instead
 */

class Button extends Component {
  static propTypes = {
    children: node,
    /** disable the button with this prop */
    disabled: bool,
    /** set button to be a link or a button */
    elementType: oneOf(["button", "link"]),
    /** supply the argument low to decrease height to 30px */
    height: string,
    /** set width to auto providing a true value for this option, by default it is 100% */
    minWidth: bool,
    onClick: func,
    /** changes background color of button */
    theme: string
  };

  static defaultProps = {
    children: null,
    disabled: false,
    elementType: "button",
    height: null,
    minWidth: false,
    onClick: () => {},
    theme: "primary"
  };

  /**
   * handles click functionality, sends the event and any additional data provided to the caller &
   * prevents default click behavior
   * @public
   *
   */
  handleClick = event => {
    const { onClick } = this.props;
    onClick({ event });
  };

  render() {
    const { elementType, theme } = this.props;
    const ButtonComponent = S.ColorThemesEnum[theme] || S.BaseButton;
    if (elementType === "link") {
      ButtonComponent.displayName = "Link";
    }
    const tag = elementType === "link" ? "a" : "button";

    return (
      <ButtonComponent as={tag} {...this.props} onClick={this.handleClick} />
    );
  }
}

export default Button;
